if (location.pathname === '/register/sign_up') {
  document.addEventListener('turbolinks:load', () => {
    const spaceName = document.getElementById('_space_name') as HTMLInputElement;
    const extraInfosCorporateName = document.getElementById('_extra_info_corporate_name') as HTMLInputElement;

    if (spaceName !== null && extraInfosCorporateName !== null) {
      spaceName.addEventListener('change', () => {
        if (extraInfosCorporateName.value.length == 0) {
          extraInfosCorporateName.value = spaceName.value
        }
      }, false);
    }

    const userName = document.getElementById('_user_name') as HTMLInputElement;
    const extraInfosPersonName = document.getElementById('_extra_info_person_name') as HTMLInputElement;

    if (userName !== null && extraInfosPersonName !== null) {
      userName.addEventListener('change', () => {
        if (extraInfosPersonName.value.length == 0) {
          extraInfosPersonName.value = userName.value
        }
      }, false);
    }
  });
}
